import {SecurityContext} from "../types/SecurityContext";

export default class SecurityContextStorage {

  private static CONTEXT: SecurityContext;

  static initialize(context: SecurityContext): SecurityContext {
    SecurityContextStorage.CONTEXT = context;
    return context;
  }

  static hasSecurityContext(): boolean {
    return SecurityContextStorage.CONTEXT !== null;
  }

  static getContext(): SecurityContext {
    if (!this.hasSecurityContext()) {
      throw Error("Security context is not initialized!");
    }
    return SecurityContextStorage.CONTEXT;
  }

}
